import { render, staticRenderFns } from "./capture-point.vue?vue&type=template&id=5a2dd34e&scoped=true&lang=pug&"
import script from "./capture-point.vue?vue&type=script&lang=js&"
export * from "./capture-point.vue?vue&type=script&lang=js&"
import style0 from "./capture-point.vue?vue&type=style&index=0&id=5a2dd34e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2dd34e",
  null
  
)

/* custom blocks */
import block0 from "@/lang/products/insurance/home-insurance/index?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231208114810%2Fcomponents%2Fproducts%2Finsurance%2Fhome-insurance%2Fcapture-point.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./capture-point.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsUserAddressCard: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/widgets/user-address-card.vue').default,WidgetsFormsAddress: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/widgets/forms/address.vue').default,SiteFeefoMiniSplitTabs: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/site/feefo-mini-split-tabs.vue').default,ProductsPillCta: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/products/pill-cta.vue').default})
